import _extends from 'babel-runtime/helpers/extends';
import _Object$keys from 'babel-runtime/core-js/object/keys';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { mediaActions, mediaSelectors } from '../redux/media-reducer';
import { getUrnFromContent, MEDIA_TYPE, parseMediaContent } from '../utils/media-utils';

// ****************************************************************************************
// withAudioParsing expects  audios  or  unsignedUri  or  src  in props
//  if props.unsignedUri, it assumes that we are getting a signed uri from that and fails if we can't
//  if props.src, it assumes that to be a uri that Just Works
//  otherwise, this parses props.audios and does all the puddle things
//  It adds a prop, 'audioUris', to the wrapped component.  'audioUris' is an
//   array of plain URIs to audio, or null.  Almost all the time it is one URI.
//
export function withAudioParsing(WrappedComponent) {
  var WrappedBase = function (_PureComponent) {
    _inherits(WrappedBase, _PureComponent);

    function WrappedBase(props) {
      _classCallCheck(this, WrappedBase);

      var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));

      _this.allPuddleResourcesHaveLoaded = function () {
        var mediaInfos = _this.getMediaInfos();
        return !!mediaInfos && mediaInfos.every(function (mInfo) {
          if (mInfo.encryptedPuddleId) {
            return !!_this.props.loadedResourceFromPuddle(mInfo.encryptedPuddleId);
          }
          return true;
        });
      };

      _this.loadFromPuddleIfRequired = function () {
        var mediaInfos = _this.getMediaInfos();
        if (mediaInfos) {
          var isRequired = false;
          mediaInfos.forEach(function (mInfo) {
            if (mInfo.encryptedPuddleId && !_this.props.loadedResourceFromPuddle(mInfo.encryptedPuddleId)) {
              _this.props.loadResourceFromPuddle(mInfo.encryptedPuddleId);
              isRequired = true;
            }
          });
          if (isRequired) {
            _this.setState({ loadingFromPuddle: true });
          }
        }
      };

      _this.getMediaInfos = function () {
        var mediaInfoz = parseMediaContent({
          mediaInfoOrArray: _this.props.audios,
          mediaType: MEDIA_TYPE.AUDIO,
          fileExtension: 'mp3',
          errorHandler: _this.props.handleError,
          isWebi: _this.props.isWebi
        });
        return mediaInfoz;
      };

      _this.audioUris = [];

      _this.getAudioUris = function () {
        // case of signed uri
        if (_this.props.unsignedUri) {
          var signedUri = _this.props.signedUri();
          if (!signedUri) {
            return null;
          }
          if (signedUri.invalid) {
            return null;
          }
          _this.audioUris.splice(0);
          _this.audioUris.push(signedUri.uri);
          return _this.audioUris;
        }
        // case of puddle loading
        if (_this.state.loadingFromPuddle) {
          return null;
        }
        // case of handing in a simple uri e.g. for local blob
        if (_this.props.src) {
          _this.audioUris.splice(0);
          _this.audioUris.push(_this.props.src);
          return _this.audioUris;
        }
        if (_this.props.audios) {
          var mediaInfos = _this.getMediaInfos();
          if (mediaInfos) {
            _this.audioUris.splice(0);
            mediaInfos.forEach(function (mInfo) {
              if (mInfo.encryptedPuddleId && _this.props.loadedResourceFromPuddle(mInfo.encryptedPuddleId)) {
                _this.audioUris.push(_this.props.loadedResourceFromPuddle(mInfo.encryptedPuddleId));
              } else {
                _this.audioUris.push(mInfo.mediaUri);
              }
            });
            return _this.audioUris;
          }
        }
        return null;
      };

      _this.refreshSignedUri = function () {
        if (_this.props.unsignedUri) {
          // Valid or not validated at all
          var signedUri = _this.props.signedUri();
          if (signedUri.valid || signedUri.valid === null) {
            _this.props.setUriExpired(_this.props.unsignedUri);
          }
          _this.props.signUri(_this.props.unsignedUri);
        }
      };

      _this.validateSignedUri = function () {
        if (_this.props.unsignedUri) {
          if (!_this.props.signedUri().invalid) {
            // already validated
            return;
          }
          _this.props.setUriValidated(_this.props.unsignedUri);
        }
      };

      _this.cleanProps = function () {
        // not excluding recording because we want to ship it to wrapped component
        var OMITTED_PROPS = ['signedUri', 'user', 'loadedResourceFromPuddle', 'loadResourceFromPuddle', 'signUri', 'setUriExpired', 'setUriValidated'];
        var cleanedProps = {};
        _Object$keys(_this.props).forEach(function (key) {
          if (!OMITTED_PROPS.includes(key)) {
            cleanedProps[key] = _this.props[key];
          }
        });
        return cleanedProps;
      };

      _this.state = {
        loadingFromPuddle: false
      };
      if (props.unsignedUri) {
        // this a call to the server to get a signedUri
        props.signUri(props.unsignedUri);
      }
      return _this;
    }

    WrappedBase.prototype.componentDidMount = function componentDidMount() {
      this.loadFromPuddleIfRequired();
    };

    WrappedBase.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevState.loadingFromPuddle) {
        if (this.allPuddleResourcesHaveLoaded()) {
          this.setState({ loadingFromPuddle: false });
        }
        return;
      }
      if (this.props.audios) {
        // following is to test whether the audios are different
        var currentAudioUrns = getUrnFromContent({
          mediaInfoOrArray: this.props.audios,
          mediaType: MEDIA_TYPE.AUDIO,
          errorHandler: this.props.handleError
        });
        var previousAudioUrns = getUrnFromContent({
          mediaInfoOrArray: prevProps.audios,
          mediaType: MEDIA_TYPE.AUDIO,
          errorHandler: this.props.handleError
        });
        if (previousAudioUrns.length !== currentAudioUrns.length || previousAudioUrns.some(function (urn) {
          return !currentAudioUrns.includes(urn);
        })) {
          this.loadFromPuddleIfRequired();
        }
      }
    };

    // returns an array, or if there was an error, null


    WrappedBase.prototype.render = function render() {
      var audioUris = this.getAudioUris();
      var audioUri = void 0;
      if (audioUris && audioUris.length >= 1) {
        audioUri = audioUris[0];
        if (audioUris.length === 1) {
          audioUris = null;
        }
      }
      var wrappedProps = this.cleanProps();
      return React.createElement(WrappedComponent, _extends({}, wrappedProps, {
        audioUri: audioUri,
        audioUris: audioUris,
        onLoadError: this.refreshSignedUri,
        onLoaded: this.validateSignedUri
      }));
    };

    return WrappedBase;
  }(PureComponent);

  var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {
      signedUri: function signedUri() {
        if (ownProps.unsignedUri) {
          return mediaSelectors.getSignedUri(state, ownProps.unsignedUri);
        }
        return null;
      },
      recording: mediaSelectors.isRecording(state),
      loadedResourceFromPuddle: function loadedResourceFromPuddle(puddleResourceId) {
        return mediaSelectors.getLoadedResource(state, puddleResourceId);
      },
      isWebi: mediaSelectors.isWebi(state)
    };
  };

  var mappedActions = {
    loadResourceFromPuddle: mediaActions.loadResourceFromPuddle,
    handleError: mediaActions.handleError,
    signUri: mediaActions.signUri,
    setUriExpired: mediaActions.setUriExpired,
    setUriValidated: mediaActions.setUriValidated
  };

  return connect(mapStateToProps, mappedActions)(WrappedBase);
}